import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LlmAnnotation } from '../structure-data.models';
import { getHighlightedSentence, truncateSentence } from './text-annotations.helpers';

// Pure by default: only re-runs when `annotation`'s reference changes, not on every
// change-detection cycle. A plain component method bound via [innerHTML] in a *matCellDef
// re-evaluates (and re-sanitizes, re-writes the DOM) on every single CD pass for every row,
// because it returns a new SafeHtml wrapper each call — that's what was freezing the page
// after switching tabs, once combined with anything else that kept triggering extra CD cycles.
@Pipe({
  name: 'highlightedSentence',
  standalone: false,
})
export class HighlightedSentencePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  // `expanded` is a plain argument (not read off `annotation`) specifically so this stays a pure
  // pipe: Angular re-invokes transform when any argument's value changes, including a primitive
  // boolean, so toggling "Show more"/"Show less" re-runs it without needing `pure: false`.
  transform(annotation: LlmAnnotation, expanded: boolean = false): SafeHtml {
    const sentence = expanded ? annotation.sentence : truncateSentence(annotation.sentence);
    return this.sanitizer.bypassSecurityTrustHtml(getHighlightedSentence(sentence, annotation.exact));
  }
}
